export default __webpack_public_path__ + "static/media/a7.13d5d3f5.png";